export default {
  componentWrapper: "history-slider py-40 ",
  slidesWrapper: "img-slider px-20 lg:20 md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  sliderWrapper:'sliderWrapper',
  slidesYearWrapper: "timeline-year-slider font-MDLZBiteType mt-40 bg-no-repeat md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  headingOuter: "heading-outer mb-20 md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  headingH2: "text-[36px] md:text-[60px] uppercase px-20 text-purple font-MDLZBiteType font-light md:leading-[72px] leading-[28.8px] leading-[43.2px] tracking-normal",
  headingH3: "font-Light text-[24px] md:text-[48px] font-light tracking-normal text-green leading-[57.6px]",
  text: "sliderDescription text-center opacity-0 ease-in duration-300 pt-[68px]",
  para: "text-black font-Regular text-[14px] md:text-[21px] tracking-[0.53px] font-light text-center",
}
